/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../../app/payments/payment-failure.component';
const styles_PaymentFailureComponent:any[] = ([] as any[]);
export const RenderType_PaymentFailureComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_PaymentFailureComponent,
  data: {}
}
);
export function View_PaymentFailureComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'style',
        'text-align:center; margin: 0 auto; margin-top: 60px;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Ups!'])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Coś poszło nie tak :( Twoja płatność nie została zarejestrowana.'])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Sprawdź status swoich płatności w module płatności.'])),
    (l()(),import0.ɵted((null as any),['\n  '])),
    (l()(),import0.ɵted((null as any),['\n  ']))
  ]
  ,(null as any),(null as any));
}
function View_PaymentFailureComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'payment-failure',([] as any[]),(null as any),(null as any),(null as any),View_PaymentFailureComponent_0,RenderType_PaymentFailureComponent)),
    import0.ɵdid(114688,(null as any),0,import1.PaymentFailureComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const PaymentFailureComponentNgFactory:import0.ComponentFactory<import1.PaymentFailureComponent> = import0.ɵccf('payment-failure',import1.PaymentFailureComponent,View_PaymentFailureComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvc3JjL2FwcC9wYXltZW50cy9wYXltZW50LWZhaWx1cmUuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvc3JjL2FwcC9wYXltZW50cy9wYXltZW50LWZhaWx1cmUuY29tcG9uZW50LnRzIiwibmc6Ly8vc3RvcmFnZS92aG9zdC9wYW5lbC5kYXRhc3BhY2UucGwvd2ViL2RhdGFzcGFjZS1jcC1kcy1mcm9udC9zcmMvYXBwL3BheW1lbnRzL3BheW1lbnQtZmFpbHVyZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvc3JjL2FwcC9wYXltZW50cy9wYXltZW50LWZhaWx1cmUuY29tcG9uZW50LnRzLlBheW1lbnRGYWlsdXJlQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBzdHlsZT1cInRleHQtYWxpZ246Y2VudGVyOyBtYXJnaW46IDAgYXV0bzsgbWFyZ2luLXRvcDogNjBweDtcIj5cbiAgICA8aDI+VXBzITwvaDI+XG4gICAgPHA+Q2/FmyBwb3N6xYJvIG5pZSB0YWsgOiggVHdvamEgcMWCYXRub8WbxIcgbmllIHpvc3RhxYJhIHphcmVqZXN0cm93YW5hLjwvcD5cbiAgICA8cD5TcHJhd2TFuiBzdGF0dXMgc3dvaWNoIHDFgmF0bm/Fm2NpIHcgbW9kdWxlIHDFgmF0bm/Fm2NpLjwvcD5cbiAgPC9kaXY+XG4gICIsIjxwYXltZW50LWZhaWx1cmU+PC9wYXltZW50LWZhaWx1cmU+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7OztNQ0FBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBa0U7SUFDOUQ7SUFBSTtJQUFTO0lBQ2I7SUFBRztJQUFvRTtJQUN2RTtJQUFHO0lBQXVEO0lBQ3REOzs7Ozs7SUNKUjtnQkFBQTs7O0lBQUE7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/payments/payment-failure.component.ngfactory.ts